import { InputGroup, Image, FormControl, Button } from "react-bootstrap";
import { Fragment, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { FormattedMessage, useIntl } from "react-intl";
import Cinema from "../Cinema/Cinema";
import searchIcon from "assets/images/falabella/search-icon.svg";
import { useHistory } from "react-router-dom";

const TeGustaLoQueVes = () => {
  // URL del video embebido con parámetro stretching=fill para que se ajuste
  const videoURL = "https://cdn.jwplayer.com/videos/nkotXDr2-PtlSoLN4.mp4";

  // Estado para la barra de búsqueda
  const [searchTerm, setSearchTerm] = useState("");
  const history = useHistory();
  const handleSearchChange = (e) => setSearchTerm(e.target.value);
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const queryParams = new URLSearchParams({ search: searchTerm }).toString();
    history.push(`/explorar?${queryParams}`);
  };

  const intl = useIntl();
  const searchPlaceholder = intl.formatMessage({ id: "app.muevete.busqueda" });

  // Estado y funciones para el modal del video
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  // Detectamos si estamos en pantalla pequeña (mobile)
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <div className="py-4 mt-5" style={{marginTop: isMobile ? "80px" : "0",}} id="cultura" name="cultura">
      <Fragment>
        {/* 🔹 BARRA DE BÚSQUEDA */}
        <div
          data-testid="search-div"
          style={{
            position: isMobile ? "relative" : "absolute",
            zIndex: 8,
            width: "100%",
            top: isMobile ? "0" : "5%",
            padding: isMobile ? "0 10px" : "0 100px",
            marginBottom: isMobile ? "20px" : "0",
            marginTop: isMobile ? "80px" : "0",
          }}
        >
          <form
            data-testid="search-form"
            onSubmit={handleSearchSubmit}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <InputGroup
              data-testid="search-input-group"
              className="mb-3"
              style={{
                width: "80%",
                borderRadius: "50px",
                overflow: "hidden",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <FormControl
                data-testid="search-input-control"
                type="search"
                placeholder={searchPlaceholder}
                aria-label="Buscar"
                value={searchTerm}
                onChange={handleSearchChange}
                style={{ border: "none", paddingLeft: "24px" }}
              />
              <Button
                data-testid="search-button"
                variant="outline-success"
                type="submit"
                style={{
                  border: "none",
                  borderRadius: "50px",
                  padding: "0.375rem 0.75rem",
                  backgroundColor: "#60B132",
                  color: "#FFFFFF",
                }}
              >
                <Image
                  data-testid="search-button-icon"
                  src={searchIcon}
                  alt="Buscar"
                  style={{ height: "20px", marginRight: "12px" }}
                />{" "}
                <FormattedMessage id="app.video.searchjobs" defaultMessage="Buscar Empleos" />
              </Button>
            </InputGroup>
          </form>
        </div>

        {/* 🔹 ESPACIO PARA TÍTULO "Quiénes somos" */}
        <div className="text-center" style={{ marginTop: "80px", marginBottom: "30px" }}>
          {/* Puedes agregar contenido aquí */}
        </div>

        {/* 🔹 VIDEO EMBEBIDO CON `iframe` (Ajustado para cubrir el contenedor) */}
        <div
          data-testid="video-cultura-player"
          className="video-cultura"
          style={{
            position: "relative",
            width: isMobile ? "85%" : "95%",
            maxWidth: "1000px",
            aspectRatio: "16 / 9",
            margin: "0 auto",
            borderRadius: "30px",
            overflow: "hidden",
            backgroundColor: "#000",
          }}
        >
          <iframe
            src={videoURL}
            title="Video"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              borderRadius: "30px",
            }}
          />
        </div>
      </Fragment>

      {/* 🔹 MODAL DEL VIDEO */}
      <Cinema
        data-testid="video-player-modal"
        show={show}
        setShow={handleClose}
        url={videoURL}
      />
    </div>
  );
};

export default TeGustaLoQueVes;
